import React from 'react'

function DescriptionHome2() {
  return (
       
    <section className="">
    <div className="lg:h-[50vh] flex flex-col items-center md:flex-row">
       <div className="w-full md:w-[40%] lg:w-[60%] lg:mx-[8%] flex flex-col justify-center items-center">
           <h1 className="text-2xl md:text-3xl font-bold font-nunito text-white my-5">
           Engage with users from around the world  on hundreds of topics everyday.
           </h1>
           <p className="md:text-xl mt-2 font-nunito font-medium text-white indent-4">
           No matter where you are, we make it easy for you to talk about things
            that are the most important to you. No matter how local or how small,
             our platform allows you to actively discuss and debate with other users 
             who are just as passionate as you are.
           </p>

       </div>

       <div className='w-full md:w-[60%] lg:w-[40%] h-[50vh] my-10 relative'>
       <div className="absolute top-0 left-[7%] bg-[#211E1E] w-[60px] h-[60px] rounded-full"/>
       <div className="absolute top-4 right-0 bg-[#211E1E] w-[73%] h-6 rounded-l-xl "/>

       <div className="absolute top-[90px] left-[30%] bg-[#211E1E] w-[60px] h-[60px] rounded-full"/>
       <div className="absolute top-[90px] right-0 bg-[#211E1E] w-[50%] h-6 rounded-l-xl "/>
       <div className="absolute top-[120px] right-0 bg-[#211E1E] w-[50%] h-6 rounded-l-xl "/>

       <div className="absolute top-[170px] right-0 bg-[#211E1E] w-[50%] h-24 rounded-l-3xl "/>

       <div className="absolute top-[280px] left-[7%] bg-[#211E1E] w-[60px] h-[60px] rounded-full"/>
       <div className="absolute top-[300px] right-0 bg-[#211E1E] w-[73%] h-6 rounded-l-xl "/>
       </div>

    </div>




   </section>
  )
}

export default DescriptionHome2
